import { openGlobalSnack } from "./snack";

export async function serverRequestError(e:any){
    const status=e.target.status;
    if(status==403){
        const res=JSON.parse(e.target.response);
        openGlobalSnack(`Error: ${res.error}`,'warning');
    }else if(status==401){
        openGlobalSnack("Você foi deslogado, atualize a página.",'error');
    }else{

        openGlobalSnack("Algum erro desconhecido aconteceu. Notifique o suporte",'error');
    }
}